<template>
  <section id="main-box">
    <div class="loading-mask" :isLoding="isLoding" v-if="isLoding"></div>
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">

        <div class="StatusNav">
          <ul>
            <li v-for="(item,index) in navlist" v-text="item.name+'('+item.count+')'"
              :class="{'StatusNavActive':item.active}" v-on:click="NavSwitch(item.id)"></li>
          </ul>
        </div>

        <div class="xblock-box">
          <div class="xblock layui-form" :class="{'FloatingNav':SelectedNum > 0}">
            <!-- <button class="layui-btn xblock-row" v-on:click="AllEdit('Bulk')">批量普通编辑<i v-if="SelectedNum > 0"
                v-text="'('+SelectedNum+')'"></i></button> -->
            <button class="layui-btn layui-btn-normal xblock-row" v-on:click="AllEdit('BulkGlobal')">批量全球编辑<i
                v-if="SelectedNum > 0" v-text="'('+SelectedNum+')'"></i></button>
            <button class="layui-btn layui-btn-danger xblock-row" v-on:click="DeleteItme('all')">批量删除<i
                v-if="SelectedNum > 0" v-text="'('+SelectedNum+')'"></i></button>
            <button class="layui-btn layui-btn-warm xblock-row" v-on:click="DeleteItme('repeat')">删除重复</button>
            <span class="x-right layui-input-inline xblock-row" v-text="'　共有数据：'+count+ '条'"></span>
            <div class="clear-both"></div>
          </div>
        </div>

        <div class="table-box-list">
          <table class="layui-table layui-form layui-table-margin" :class="{'FloatingMargin':SelectedNum > 0}">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" class="cxall" lay-filter="cxall" name="cxall" lay-skin="primary">
                </th>
                <th>图片</th>
                <th>来源</th>
                <th>价格</th>
                <th>标题</th>
                <th>链接</th>
                <th>状态</th>
                <th>时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody v-viewer>
              <tr v-for="(item,index) in list">
                <td class="cx-box NoSelect" :data-ix="index">
                  <div><input type="checkbox" lay-filter="cx" lay-skin="primary" :data-index="index"
                      :checked="item.active"></div>
                  <div class="list-number" v-text="index+1"></div>
                </td>
                <td>
                  <div class="table_img">
                    <img :src="$picture(item.image)">
                  </div>
                </td>
                <td style="min-width: 60px;">
                  <i v-if="item.type == 'shopee'">shopee</i>
                  <i v-else-if="item.type == 'pinduoduo'">拼多多</i>
                  <i v-else-if="item.type == 'taobao'">淘宝</i>
                  <i v-else-if="item.type == 'tmall'">天猫</i>
                  <i v-else-if="item.type == '1688'">1688</i>
                  <i v-else-if="item.type == 'duoduopifa'">多多批发</i>
                  <i v-else-if="item.type == 'jd'">京东</i>
                  <i v-else-if="item.type == 'aliexpress'">速卖通</i>
                  <i v-else-if="item.type == 'yiwugo'">义乌购</i>
                </td>
                <td style="min-width: 100px;">
                  <i style="font-size: 13px;" v-if="(item.min_price||item.max_price) && item.type !='shopee'">￥</i><i
                    v-if="item.min_price != item.max_price" v-text="item.min_price+'~'+item.max_price"></i><i v-else
                    v-text="item.min_price"></i>
                </td>
                <td style="min-width: 150px;max-width:400px;word-break:break-all;">
                  <i v-if="item.is_repeat" class="status-box-red" style="padding:2px;">重复采集</i>
                  <i v-text="item.name"></i>
                </td>
                <td>
                  <div class="openabox" style="overflow: hidden;">
                    <a :href="item.origin" target="_blank" class="onlyTwoRow Alabel"
                      style="width: 200px;word-break:break-all;" v-text="item.origin"></a>
                  </div>
                </td>
                <td>
                  <div style="width: 80px;">
                    <i v-if="item.is_upload == 1" class="status-box status-box-orange">已发布</i>
                    <i v-else class="status-box status-box-green">未发布</i>
                  </div>
                </td>
                <td v-text="item.created_at"></td>
                <td class="btn-arr">
                  <!-- <button class="layui-btn" v-on:click="OpenPage('Edit',item.id)">普通店编辑</button> -->
                  <button class="layui-btn layui-btn-normal" v-on:click="OpenPage('EditGlobal',item.id)">全球店编辑</button>
                  <button class="layui-btn layui-btn-danger" v-on:click="DeleteItme(item.id)">删除</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

        <!--scroll to top-->
        <div class="scroll-top">
          <i class="fa fa-angle-up" aria-hidden="true"></i>
        </div>

      </div>

      <!-- 分页 -->
      <div class="page-box">
        <div id="pagebox" class="pagebox"></div>
      </div>

      <!-- loading -->
      <K-Loading v-if="loading"></K-Loading>

      <!-- toast -->
      <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

      <!-- 确认框 -->
      <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

    </div>
  </section>
</template>

<script>
  var self, form, layer, laypage, isRefresh;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'Promote',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        SelectedNum: 0,
        isLoding: true,
        id: null,
        itemid: null,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        page_num: 20,
        isloding: false,
        list: [],
        shops: [],
        navlist: [{
          id: 0,
          count: 0,
          active: false,
          name: "全部",
        }, {
          id: 1,
          count: 0,
          active: false,
          name: "未发布",
        }, {
          id: 2,
          count: 0,
          active: false,
          name: "已发布",
        }],
        merchants: [],
      }
    },
    updated() {
      if (form) {
        form.render();
      }
      self.NumberCheck();
    },
    watch: {
      $route: {
        handler(nv, ov) {
          if (nv.query.id) {
            if (self.id != nv.query.id) {
              self.id = nv.query.id;
              self.list = [];
              self.ProductList(nv.query.id);
            }
          } else {
            if (self.list.length > 0) {
              $('.pagebox').show();
            }
          }
        }
      },
      deep: true
    },
    mounted() {
      self = this;
      self.SetNavActive("上架", self.$route.name);
      let id = self.$route.query.id; //采集商品ID
      scrollTop(); //监听滚动置顶

      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;

        if (id) {
          self.NavSwitch(1, id);
        } else {
          self.NavSwitch(1);
        }
        self.get_shop_list();
        self.get_merchant_list();
        self.get_count();
        self.VersionCheck(); //版本检测

        //全选
        form.on('checkbox(cxall)', function(data) {
          var child = $(".cx-box input[type='checkbox']");
          var status = data.elem.checked;
          var num = 0;
          child.each(function(index, item) {
            item.checked = data.elem.checked;
            self.list[index].active = status;
            if (status) {
              num++
            }
          });
          form.render('checkbox');
        });

        //单选
        form.on('checkbox(cx)', function(data) {
          let ix = data.elem.dataset.index;
          let status = data.elem.checked;
          self.list[ix].active = status;
          form.render('checkbox');
        });

        //单选
        $("#main-box").on("click", '.cx-box', function(e) {
          var ix = $(this).attr("data-ix");
          if (self.list[ix].active) {
            self.list[ix].active = false;
          } else {
            self.list[ix].active = true;
          }
          form.render('checkbox');
        });

      });

      $(".layui-body").scroll(function() {
        let scrollTop = $(this).scrollTop();
        if (scrollTop > 30) {
          $(".FloatingNav").css({
            top: 70 + 'px'
          });
        } else {
          $(".FloatingNav").css({
            top: 'auto'
          });
        }
      })

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      VersionCheck() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/version/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(res) {
          var json = res.data;
          if (json.code == 200) {
            if (json.datas.version != localStorage.getItem("ExShopee_Version")) {
              localStorage.setItem("ExShopee_Version", json.datas.version);
              window.location.reload(true);
            }
          }
        }).catch(function(error) {
          console.log(error);
        })
      },
      DeleteItme(id) {
        if (id == "all") {
          self.Confirm.txt = "是否确认批量删除？";
          self.Confirm.te = 'all';
        } else if (id == "repeat") {
          self.Confirm.txt = "是否确认删除当前页重复商品？";
          self.Confirm.te = 'repeat';
        } else {
          self.Confirm.txt = "是否确认删除？"
          self.Confirm.te = 'one';
        }
        self.Confirm.style = 1;
        self.Confirm.state = true;
        self.itemid = id;
      },
      ProductList(id) {
        let param = new URLSearchParams()
        param.append('type', self.ix)
        if (id) {
          param.append('id', id)
        }
        param.append('num', self.page_num)
        self.isLoding = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + '/collection_list/?page=' + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(json) {
          self.isLoding = false;
          var json = json.data;
          if (json.code == 200) {
            var datas = json.datas;
            var list = datas.list;
            if (datas.page) {
              for (let i in list) {
                list[i].data = JSON.parse(list[i].data)
                let max_price = list[i].data.price;
                let min_price = list[i].data.price;
                for (let y in list[i].data.models) {
                  if (list[i].data.models[y].price > max_price) {
                    max_price = list[i].data.models[y].price;
                  }
                  if (list[i].data.models[y].price < min_price) {
                    min_price = list[i].data.models[y].price;
                  }
                }
                list[i].min_price = min_price;
                list[i].max_price = max_price;
                list[i].active = false;
              }
              // console.log(list)
              self.list = list;
              self.total = datas.total;
              if (id) {
                self.GoToPage("/Col");
                location.reload();
              }

              self.count = datas.page.count;
              self.ShowPage(self, laypage, "ProductList"); //分页
              $('.pagebox').show();
            }
          } else if (json.code == 401) {
            layer.alert('请先前往登录！', {
              title: "ExShopee",
              closeBtn: 0
            }, function() {
              layer.closeAll();
              self.GoToPage("/");
            });
          } else {
            self.list = [];
            $('.pagebox').hide();

            //自动换页
            if (self.page > 1) {
              self.page -= 1;
              self.ProductList();
            }
          }
        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })

      },
      get_shop_list() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_shop/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var datalist = datas.list;
            if (datalist.length > 0) {
              self.shops = datalist;
            }
          });

        }).catch(function(error) {
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      get_merchant_list() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_merchant/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var datalist = datas.list;
            if (datalist.length > 0) {
              self.merchants = datalist;
            }
          });

        }).catch(function(error) {
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      OpenPage(url, id) {
        if (url == "Edit") {
          if (self.shops.length <= 0) {
            layer.msg("店铺为空，请先授权店铺！");
            return;
          }
        }
        if (url == "EditGlobal") {
          if (self.merchants.length <= 0) {
            layer.msg("全球店为空，请先授权全球店！");
            return;
          }
        }

        localStorage.setItem("ExShopee_EditType", false);
        self.$router.push({
          path: url + '?id=' + id
        }) // 路由跳转
      },
      get_count() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/p_get_status_number_collection/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            for (let i in self.navlist) {
              self.navlist[i].count = datas.count_arr[i]
            }
          });

        }).catch(function(error) {
          console.log(error);
        })
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (data.state) {
          var ids = [];
          if (self.Confirm.te == "all") {
            for (let i in self.list) {
              if (self.list[i].active) {
                ids.push(self.list[i].id);
              }
            }
          } else if (self.Confirm.te == "repeat") {
            for (let i in self.list) {
              if (self.list[i].is_repeat) {
                ids.push(self.list[i].id);
              }
            }
          } else {
            ids.push(self.itemid);
          }

          self.loading = true;
          self.Confirm.state = false;
          $.ajax({
            url: self.GetServerUrl() + "/collection_del_list/",
            type: 'post',
            data: {
              id: JSON.stringify(ids)
            },
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            },
            success: function(res) {
              self.loading = false;
              layer.close(layer.index);
              var json = JSON.parse(res);
              if (json.code == 200) {
                self.ToastFun(0, json.msg); //弹窗提醒
                $('.cxall').prop('checked', false);
                self.ProductList();
              } else {
                self.ToastFun(1, json.msg); //弹窗提醒
              }
            },
            error: function(error) {
              self.loading = false;
              self.ToastFun(2, error); //弹窗提醒
            }
          })
        }
      },
      AllEdit(url) {
        var ids = [];
        for (let i in self.list) {
          if (self.list[i].active) {
            ids.push(self.list[i].id);
          }
        }
        if (ids.length > 0) {

          if (url == "Bulk") {
            if (self.shops.length <= 0) {
              layer.msg("店铺为空，请先授权店铺！");
              return;
            }
          }
          if (url == "BulkGlobal") {
            if (self.merchants.length <= 0) {
              layer.msg("全球店为空，请先授权全球店！");
              return;
            }
          }

          localStorage.setItem("ExShopee_EditIds", JSON.stringify(ids));
          localStorage.setItem("ExShopee_EditType", false);
          self.$router.push({
            path: url
          }) // 路由跳转
        } else {
          self.ToastFun(1, "请选择产品！"); //弹窗提醒
        }
      },
      NumberCheck() {
        let num = 0;
        for (let i in self.list) {
          if (self.list[i].active) {
            num++
          }
        }
        self.SelectedNum = num;
        let scrollTop = $(".layui-body").scrollTop();
        if (scrollTop > 30) {
          $(".FloatingNav").css({
            top: 70 + 'px'
          });
        } else {
          $(".FloatingNav").css({
            top: 'auto'
          });
        }
      },
      NavSwitch(ix, id) {
        $('.cxall').prop('checked', false);
        self.GoToPage('/Col?ix=' + ix); // 路由跳转
        for (let i in self.navlist) {
          self.navlist[i].active = false;
        }
        self.navlist[ix].active = true;
        self.ix = ix;
        self.list = [];
        if (id) {
          self.ProductList(id);
        } else {
          self.ProductList();
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .promote-url {
    padding-left: 10px;
    line-height: 40px;
  }

  .StatusNav ul li:last-child {
    margin-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/Col.vue